import React from "react";
import ReactDOM from "react-dom";
import { setConsole, ReactQueryConfigProvider } from "react-query";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import * as Sentry from "@sentry/react";

import App from "components/App";
import {
  NotificationsContainer,
  ErrorBoundary,
} from "fe-shared/src/components";

import config from "config";
import queryConfig from "fe-shared/src/helpers/queryConfig";
import { beforeSend } from "fe-shared/src/helpers/sentry";
import { initializeAxiosConfig } from "fe-shared/src/helpers/axiosConfig";

import "./i18n";
import "fe-shared/src/i18n";

import * as serviceWorker from "./serviceWorker";
import { getApiHostUrl } from "config";

import "fe-shared/src/styles/core.scss";

const history = createBrowserHistory();

Sentry.init({
  dsn: config.SENTRY_DSN,
  environment: config.SENTRY_ENV,
  release: config.SENTRY_VERSION,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV5BrowserTracingIntegration({ history }),
  ],
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
  ],
  tracesSampleRate: 1.0,
  debug: process.env.NODE_ENV !== "production",
  beforeSend,
});

// Initialize axios with dynamic configuration
initializeAxiosConfig(getApiHostUrl);

if (process.env.NODE_ENV === "production") {
  setConsole({
    error: () => {},
    warn: () => {},
    log: () => {},
  });
}

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorBoundary />}>
      <ReactQueryConfigProvider config={queryConfig}>
        <Router history={history}>
          <App />
        </Router>
        <NotificationsContainer />
      </ReactQueryConfigProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
